import { Button } from '@breetometer/components';
import { Otp } from 'BreetComponents';
import { useOtpApi } from 'BreetHooks';
import { useCallback } from 'react';

import type { IOTPForm } from './OTP/helpers';

const OtpForm = ({
	className,
	errorMessage,
	onSubmit,
	otpLength,
	isLoading,
	resendOtpLoading,
	onChange,
	onResend,
	buttonTitle,
	value,
	position = 'center',
	resendOtp = true,
	cta,
}: IOTPForm) => {
	const { otpRef, resetOtpInputValues } = useOtpApi();

	const handleResend = useCallback(
		(restartCountDown?: () => void) => {
			onResend?.(restartCountDown);
			resetOtpInputValues();
		},
		[onResend, resetOtpInputValues]
	);

	return (
		<form
			className={className}
			onSubmit={onSubmit}
			data-testid='otp-form'
		>
			<Otp.Input
				otpLength={otpLength}
				onChange={onChange}
				error={errorMessage}
				position={position}
				maskInputValue
				ref={otpRef}
				data-testid='otp-input'
			/>

			{(!!(onResend && resendOtp) || cta) && (
				<Otp.Resend
					isLoading={isLoading ?? resendOtpLoading}
					onResend={handleResend}
					errorMessage={errorMessage}
					cta={cta}
				/>
			)}

			<Button
				label={buttonTitle ?? 'Continue'}
				disabled={!!errorMessage || (value?.length ?? 0) < otpLength}
				isLoading={isLoading}
				className={!resendOtp || !onResend ? 'reset-otp-btn' : ''}
				type='submit'
			/>
		</form>
	);
};

export default OtpForm;
